import React from "react";

export default function SubscriberListItem({ user, evenIndex }) {
  return (
    <tr className={evenIndex ? "bg-white" : "bg-gray-50"}>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          {/* <div className="flex-shrink-0 h-10 w-10">{user.phoneNumber}</div> */}
          <div className="text-sm text-gray-500">+{user.phoneNumber}</div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-500">{user.operator}</div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-500">{user.amount}</div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        {user.active ? (
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
            Active
          </span>
        ) : (
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-600">
            Deactivated
          </span>
        )}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
        <button type="button" className="text-indigo-600 hover:text-indigo-900">
          Deactivate
        </button>
      </td>
    </tr>
  );
}
